// extracted by mini-css-extract-plugin
export var radioInputRow = "v_r4";
export var radioInputColumn = "v_r5";
export var inputOptionRow = "v_qq";
export var inputOptionColumn = "v_qr";